import React from 'react';

import Tag from 'components/tags/tag';
import { formatDate } from 'helpers/formatters/date_time_formats';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filter, Filters } from './types';

interface Props {
  changeFilter: (filter: Partial<Filters>) => void;
  filter: Filter;
  schema: CustomFieldSchema;
}

export default function CustomFieldFilterTag({ changeFilter, filter, schema }: Props) {
  let label = filter;
  if (typeof filter === 'object') {
    let labelParts: (number | string)[] = [];

    if (filter.min != null && filter.min !== '') {
      labelParts.push(filter.min);
    }

    if (filter.max != null && filter.max !== '') {
      labelParts.push(filter.max);
    }

    if (schema.valueType === 'date') {
      labelParts = labelParts.map(part => formatDate(part));
    }

    label = labelParts.join(' - ');
  }

  function removeFilter() {
    changeFilter({ [schema.slug]: undefined });
  }

  return (
    <Tag removable onRemove={removeFilter}>
      {schema.label}: {label}
    </Tag>
  );
}
